// API Configuration
export const API_BASE_URL = "https://n8n.hyveappliedintelligence.com/webhook";

// Application sections with subsections
export const SECTIONS = [
  {
    id: "overview",
    name: "Overview",
    icon: "LayoutDashboard",
    pages: [{ id: "dashboard", name: "Platform Status", icon: "Activity" }],
  },
  {
    id: "client-management",
    name: "Client Management",
    icon: "Users",
    pages: [
      { id: "client-onboarding", name: "New Client Setup", icon: "Rocket" },
      { id: "facilities", name: "Facilities", icon: "Building" },
      { id: "clients", name: "Clients", icon: "Users" },
      { id: "users", name: "Users", icon: "User" },
      { id: "client-to-user", name: "Client to User", icon: "Link" },
      { id: "products", name: "Products", icon: "Package" },
      { id: "orders", name: "Orders", icon: "ShoppingCart" },
      { id: "facility-services", name: "Facility Services", icon: "HardDrive" },
      { id: "facility-users", name: "Facility Users", icon: "UserCheck" },
      { id: "service-access", name: "User Access", icon: "Shield" },
      { id: "provision", name: "Provision Facility", icon: "Rocket" },
    ],
  },
  {
    id: "data-mapping",
    name: "Data Mapping",
    icon: "Map",
    pages: [
      { id: "datamaps", name: "DataMap", icon: "MapPin" },
      { id: "indicators", name: "Indicators", icon: "Activity" },
      { id: "results", name: "Results", icon: "FileText" },
    ],
  },
  {
    id: "vector-management",
    name: "Vector Management",
    icon: "Database",
    pages: [
      { id: "vector-manager", name: "Vector Manager", icon: "Database" },
      { id: "query-pinecone", name: "Query Pinecone", icon: "Search" },
      { id: "data-quality", name: "Data Quality", icon: "BarChart" },
    ],
  },
  {
    id: "podcast",
    name: "PodCast",
    icon: "Mic",
    pages: [
      { id: "podcasts", name: "Podcasts", icon: "Radio" },
      { id: "episodes", name: "Episodes", icon: "List" },
      { id: "hosts", name: "Hosts", icon: "Users" },
      { id: "styles", name: "Styles", icon: "Palette" },
      { id: "prompts", name: "Prompts", icon: "MessageSquare" },
      { id: "episode-details", name: "Episode Details", icon: "FileAudio" },
    ],
  },
  {
    id: "knowledge-base",
    name: "Knowledge Base",
    icon: "Brain",
    pages: [
      { id: "rag-documents", name: "Document Manager", icon: "FileText" },
      { id: "kb-review-queue", name: "KB Review Queue", icon: "ClipboardList" },
      { id: "gap-tasks", name: "Gap Tasks", icon: "AlertCircle" },
      { id: "rag-chatbot", name: "KB Chat", icon: "MessageSquare" },
      { id: "kb-templates", name: "Templates", icon: "Layout" },
      { id: "scheduled-briefings", name: "Briefings", icon: "Calendar" },
      {
        id: "calendar-integration",
        name: "Calendar Integration",
        icon: "Calendar",
      },
      { id: "api-access", name: "API Access", icon: "Key" },
      { id: "channels", name: "Channels", icon: "Radio" },
      { id: "metadata-schema", name: "Metadata Schema", icon: "Database" },
    ],
  },
  {
    id: "federation",
    name: "Federation",
    icon: "Globe",
    pages: [
      { id: "federation-settings", name: "Federation Settings", icon: "Globe" },
      { id: "topic-taxonomy", name: "Topic Taxonomy", icon: "BookOpen" },
      { id: "events-admin", name: "Events", icon: "Calendar" },
    ],
  },
  {
    id: "surveys",
    name: "Surveys",
    icon: "ClipboardList",
    pages: [{ id: "surveys", name: "Surveys", icon: "ClipboardList" }],
  },
  {
    id: "billing",
    name: "Billing",
    icon: "CreditCard",
    pages: [
      {
        id: "billing-management",
        name: "Plans & Payments",
        icon: "CreditCard",
      },
    ],
  },
  {
    id: "analytics",
    name: "Analytics",
    icon: "BarChart3",
    pages: [
      {
        id: "conversation-analytics",
        name: "Conversations",
        icon: "MessageSquare",
      },
      { id: "usage-dashboard", name: "Usage", icon: "Activity" },
      { id: "feedback-dashboard", name: "Feedback", icon: "ThumbsUp" },
    ],
  },
  {
    id: "my-portal",
    name: "My Portal",
    icon: "User",
    pages: [
      { id: "my-conversations", name: "Conversations", icon: "MessageSquare" },
      { id: "my-usage", name: "Usage", icon: "Activity" },
      { id: "my-documents", name: "Documents", icon: "FileText" },
      { id: "my-billing", name: "Billing", icon: "CreditCard" },
      { id: "my-settings", name: "Account Settings", icon: "User" },
    ],
  },
  {
    id: "plm",
    name: "Prompt Engineering",
    icon: "Bot",
    pages: [{ id: "plm-chatbot", name: "Prompt Studio", icon: "Bot" }],
  },
  {
    id: "telegram",
    name: "Telegram Bot",
    icon: "Send",
    pages: [
      { id: "telegram-config", name: "Bot Config", icon: "Settings" },
      {
        id: "telegram-violations",
        name: "Mod Violations",
        icon: "AlertTriangle",
      },
    ],
  },
  {
    id: "marketing",
    name: "Marketing Director",
    icon: "Megaphone",
    pages: [
      { id: "inference-prompts", name: "Agent Prompts", icon: "MessageSquare" },
    ],
  },
  {
    id: "broadcasts",
    name: "Broadcasts",
    icon: "Megaphone",
    pages: [
      {
        id: "broadcast-composer",
        name: "Compose Broadcast",
        icon: "Megaphone",
      },
    ],
  },
  {
    id: "construction",
    name: "Construction",
    icon: "Building",
    pages: [{ id: "permit-sources", name: "Permit Sources", icon: "MapPin" }],
  },
  {
    id: "operations",
    name: "Operations",
    icon: "Zap",
    pages: [
      { id: "system-messages", name: "System Messages", icon: "Bell" },
      { id: "webhook-management", name: "Webhooks", icon: "Zap" },
      { id: "log-viewer", name: "Service Logs", icon: "ScrollText" },
    ],
  },
  {
    id: "infrastructure",
    name: "Infrastructure",
    icon: "Server",
    pages: [
      { id: "sftp-management", name: "SFTP Directories", icon: "FolderOpen" },
    ],
  },
  {
    id: "n8n",
    name: "N8N",
    icon: "Workflow",
    pages: [
      { id: "active-workflows", name: "Active Workflows", icon: "Play" },
      { id: "clone-workflow", name: "Clone Workflow", icon: "Copy" },
      { id: "backup", name: "Backup", icon: "HardDrive" },
      { id: "upgrade", name: "Upgrade", icon: "ArrowUpCircle" },
    ],
  },
  {
    id: "github",
    name: "GitHub",
    icon: "Github",
    pages: [
      { id: "push-to-github", name: "Push to GitHub", icon: "Upload" },
      { id: "my-issues", name: "My Issues", icon: "AlertCircle" },
    ],
  },
];

// Role definitions
export const USER_ROLES = [
  { value: "viewer", label: "Viewer" },
  { value: "user", label: "User" },
  { value: "admin", label: "Admin" },
  { value: "manager", label: "Manager" },
];

export const CLIENT_ACCESS_ROLES = [
  { value: "viewer", label: "Viewer" },
  { value: "editor", label: "Editor" },
  { value: "admin", label: "Admin" },
];

// Frequency options
export const FREQUENCIES = [
  { value: "daily", label: "Daily" },
  { value: "weekly", label: "Weekly" },
  { value: "monthly", label: "Monthly" },
  { value: "realtime", label: "Real-time" },
];

// Delivery methods
export const DELIVERY_METHODS = [
  { value: "email", label: "Email" },
  { value: "api", label: "API" },
  { value: "webhook", label: "Webhook" },
  { value: "database", label: "Database" },
];

// Product types
export const PRODUCT_TYPES = [
  { value: "rag", label: "RAG" },
  { value: "slm", label: "SLM" },
  { value: "private_llm", label: "Private LLM" },
  { value: "telegram_bot", label: "Telegram Bot" },
  { value: "voip", label: "VoiceIQ" },
  { value: "podcast", label: "AI Podcast Studio" },
  { value: "article", label: "Article Generator" },
  { value: "email_intelligence", label: "Email Intelligence" },
  { value: "construction", label: "BuildIQ Construction" },
  { value: "combo", label: "Combo" },
];

// Product codes (the 5 purchasable products)
export const PRODUCT_CODES = [
  {
    value: "RAG",
    label: "RAG Knowledge Base",
    type: "rag",
    rag: true,
    slm: false,
    llm: false,
  },
  {
    value: "SLM",
    label: "Custom AI Model",
    type: "slm",
    rag: false,
    slm: true,
    llm: false,
  },
  {
    value: "PRIVATE_LLM",
    label: "Private Hosted LLM",
    type: "private_llm",
    rag: false,
    slm: false,
    llm: true,
  },
  {
    value: "RAG_SLM",
    label: "RAG + Custom Model",
    type: "combo",
    rag: true,
    slm: true,
    llm: false,
  },
  {
    value: "PRIVATE_LLM_RAG",
    label: "Private LLM + RAG",
    type: "combo",
    rag: true,
    slm: false,
    llm: true,
  },
  {
    value: "TELEGRAM_BOT",
    label: "Telegram Bot",
    type: "telegram_bot",
    rag: false,
    slm: false,
    llm: false,
  },
  {
    value: "VOICEIQ",
    label: "VoiceIQ",
    type: "voip",
    rag: false,
    slm: false,
    llm: false,
  },
  {
    value: "PODCAST",
    label: "AI Podcast Studio",
    type: "podcast",
    rag: false,
    slm: false,
    llm: false,
  },
  {
    value: "ARTICLE_GEN",
    label: "Article Generator",
    type: "article",
    rag: false,
    slm: false,
    llm: false,
  },
  {
    value: "EMAIL_INTEL",
    label: "Email Intelligence",
    type: "email_intelligence",
    rag: false,
    slm: false,
    llm: false,
  },
  {
    // migration 134's product; 293 makes ordering it provision 'construction'
    value: "CONSTRUCTION_SUITE",
    label: "BuildIQ Construction",
    type: "construction",
    rag: false,
    slm: false,
    llm: false,
  },
];

// Service types (individual infrastructure services)
// CANONICAL service-type list for the platform (facility_services.service_type).
// Keep in sync with SERVICE_META in client-portal/src/App.js — the two portals
// are separate builds, so this list is duplicated there with the same values.
export const SERVICE_TYPES = [
  { value: "rag", label: "RAG", color: "blue" },
  { value: "slm", label: "SLM", color: "purple" },
  { value: "private_llm", label: "Private LLM", color: "amber" },
  { value: "datamap", label: "Data Maps", color: "emerald" },
  { value: "podcast", label: "AI Podcast Studio", color: "rose" },
  { value: "pas", label: "Prior Auth Support", color: "teal" },
  { value: "patient_aftercare", label: "Patient Aftercare", color: "violet" },
  { value: "telegram_bot", label: "Telegram Bot", color: "cyan" },
  { value: "voip", label: "VoiceIQ", color: "indigo" },
  { value: "article", label: "Article Generator", color: "green" },
  { value: "email_intelligence", label: "Email Intelligence", color: "orange" },
  { value: "video", label: "Video Studio", color: "fuchsia" },
  { value: "construction", label: "BuildIQ Construction", color: "yellow" },
  { value: "marketing", label: "Marketing Director", color: "red" },
  { value: "distribution", label: "Distribution", color: "sky" },
];

// Order statuses
export const ORDER_STATUSES = [
  { value: "pending", label: "Pending", color: "slate" },
  { value: "provisioning", label: "Provisioning", color: "yellow" },
  { value: "active", label: "Active", color: "green" },
  { value: "suspended", label: "Suspended", color: "red" },
  { value: "cancelled", label: "Cancelled", color: "slate" },
];

// Provisioning statuses
export const PROVISIONING_STATUSES = [
  { value: "not_started", label: "Not Started", color: "slate" },
  { value: "in_progress", label: "In Progress", color: "yellow" },
  { value: "completed", label: "Completed", color: "green" },
  { value: "failed", label: "Failed", color: "red" },
];

// Service statuses
export const SERVICE_STATUSES = [
  { value: "provisioning", label: "Provisioning", color: "yellow" },
  { value: "active", label: "Active", color: "green" },
  { value: "suspended", label: "Suspended", color: "red" },
  { value: "decommissioned", label: "Decommissioned", color: "slate" },
];

// Billing cycles
export const BILLING_CYCLES = [
  { value: "monthly", label: "Monthly" },
  { value: "annual", label: "Annual" },
  { value: "usage", label: "Usage-Based" },
];

// Service access roles
export const SERVICE_ACCESS_ROLES = [
  { value: "viewer", label: "Viewer" },
  { value: "user", label: "User" },
  { value: "admin", label: "Admin" },
];

// Auth URL
export const AUTH_URL = process.env.REACT_APP_AUTH_URL || "/auth";

// Marketing Director service (FastAPI)
export const MARKETING_API_URL =
  process.env.REACT_APP_MARKETING_URL ||
  "https://marketing.hyveappliedintelligence.com";

// BuildIQ construction service (FastAPI)
export const BUILDIQ_API_URL =
  process.env.REACT_APP_BUILDIQ_URL ||
  "https://buildiq.hyveappliedintelligence.com";

// Section permissions by role
export const SECTION_PERMISSIONS = {
  overview: ["admin"],
  "client-management": ["admin", "manager"],
  billing: ["admin", "manager"],
  "data-mapping": ["admin", "manager"],
  "vector-management": ["admin"],
  podcast: ["admin"],
  "knowledge-base": ["admin", "manager"],
  analytics: ["admin", "manager"],
  federation: ["admin"],
  surveys: ["admin", "manager"],
  // "facility:" prefix means: also visible if the user has that facility_role.
  // Add "facility:<role>" entries as new product roles are defined.
  marketing: ["admin"],
  // Hyve staff only: a permit source serves every facility that follows it.
  // Matches STAFF_ROLES in buildiq/app/routes/permit_sources.py.
  construction: ["admin", "manager"],
  broadcasts: ["admin", "facility:broadcasts_composer"],
  operations: ["admin"],
  infrastructure: ["admin"],
  plm: ["admin"],
  n8n: ["admin"],
  github: ["admin"],
  // "my-portal" — no entry means visible to ALL authenticated users
};

// Where an invited user lands after setting their password.
//
// MUST stay in step with ALLOWED_RESET_ORIGINS in the auth service — an origin
// it does not recognise is silently swapped for APP_URL, so a typo sends
// people somewhere else with no error. FACILITY_SLUG_ORIGINS there also
// decides which of these get a /{FACILITY_ID} path appended.
//
// Note the default is deliberately NOT window.location.origin. Invites used to
// carry whichever console the admin happened to be in, which meant an invited
// field user was pointed at the admin portal — a site they cannot use.
export const INVITE_DESTINATIONS = [
  {
    id: "https://fieldiq.hyveappliedintelligence.com",
    label: "FieldIQ — field app (walk lists, job routes)",
  },
  {
    id: "https://buildiq.hyveappliedintelligence.com",
    label: "BuildIQ — construction office",
  },
  {
    id: "https://app.hyveappliedintelligence.com",
    label: "Client Portal — facility admins",
  },
  // Deliberately NOT an option: admin.hyveappliedintelligence.com. These are
  // all facility-user invites, and the admin console is platform staff only —
  // an invited user cannot use it. Offering it only creates the chance to
  // send 600 people somewhere useless. (It stays in the auth service's
  // ALLOWED_RESET_ORIGINS, which is a different list: platform staff still
  // reset their OWN passwords from there.)
];

export const DEFAULT_INVITE_DESTINATION = INVITE_DESTINATIONS[0].id;

// Facility admins (e.g. the first admin created by onboarding) work here.
export const CLIENT_PORTAL_URL = "https://app.hyveappliedintelligence.com";
